module.exports = __webpack_public_path__ + "static/media/B35901-LAT Decision .340db214.pdf";